function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.341 5.356c.219-.219.515-.341.824-.341.31 0 .606.122.824.34l5.004 5.004 5.003-5.003c.108-.111.236-.2.379-.261.142-.061.295-.094.45-.095.154-.001.308.028.45.087.144.058.274.145.384.254.11.11.196.24.254.383.059.143.088.297.087.452-.001.154-.034.307-.095.45-.06.142-.15.27-.26.378l-5.004 5.003 5.003 5.004c.213.22.33.514.327.82-.002.305-.125.598-.341.814-.216.216-.508.338-.814.34-.306.003-.6-.114-.82-.326l-5.003-5.004-5.004 5.004c-.22.212-.514.33-.82.327-.305-.003-.597-.125-.814-.341-.216-.216-.338-.509-.34-.814-.004-.306.114-.6.326-.82l5.004-5.004L5.34 7.004C5.123 6.785 5 6.489 5 6.18c0-.31.123-.606.341-.824z",
  clipRule: "evenodd"
});

function SvgClose24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose24);
export default __webpack_public_path__ + "static/media/close24.fe841f48.svg";
export { ForwardRef as ReactComponent };